export const REGISTER_COMPANY_BEGIN = 'REGISTER_COMPANY_BEGIN'
export const REGISTER_COMPANY_SUCCESS = 'REGISTER_COMPANY_SUCCESS'
export const REGISTER_COMPANY_ERROR = 'REGISTER_COMPANY_ERROR'
